export default () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" fill="none" viewBox="0 0 2 2">
		<circle cx="1" cy="1" r="1" fill="#969392" />
	</svg>
);
